import { buttonEmits as N, buttonProps as P } from "./index605.js";
import { defineComponent as w, computed as A, openBlock as s, createBlock as i, resolveDynamicComponent as a, mergeProps as D, unref as t, withCtx as r, createElementBlock as k, Fragment as F, renderSlot as u, normalizeClass as y, createCommentVNode as b } from "vue";
import { ElIcon as g } from "./index538.js";
import { useButton as K } from "./index726.js";
import { useButtonCustomStyle as V } from "./index727.js";
import { useNamespace as _ } from "./index559.js";
var O = /* @__PURE__ */ w({
  name: "ElButton",
  __name: "button",
  props: P,
  emits: N,
  setup(o, { expose: v, emit: C }) {
    const l = o, B = C, $ = V(l), e = _("button"), {
      _ref: m,
      _size: c,
      _type: d,
      _disabled: f,
      _props: h,
      _plain: E,
      _round: S,
      _text: z,
      shouldAddSpace: p,
      handleClick: x
    } = K(l, B), I = A(() => [
      e.b(),
      e.m(d.value),
      e.m(c.value),
      e.is("disabled", f.value),
      e.is("loading", l.loading),
      e.is("plain", E.value),
      e.is("round", S.value),
      e.is("circle", l.circle),
      e.is("text", z.value),
      e.is("link", l.link),
      e.is("has-bg", l.bg)
    ]);
    return v({
      /** @description button html element */
      ref: m,
      /** @description button size */
      size: c,
      /** @description button type */
      type: d,
      /** @description button disabled */
      disabled: f,
      /** @description whether adding space */
      shouldAddSpace: p
    }), (n, j) => (s(), i(a(o.tag), D({
      ref_key: "_ref",
      ref: m
    }, t(h), {
      class: I.value,
      style: t($),
      onClick: t(x)
    }), {
      default: r(() => [
        o.loading ? (s(), k(
          F,
          { key: 0 },
          [
            n.$slots.loading ? u(n.$slots, "loading", { key: 0 }) : (s(), i(t(g), {
              key: 1,
              class: y(t(e).is("loading"))
            }, {
              default: r(() => [
                (s(), i(a(o.loadingIcon)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"]))
          ],
          64
          /* STABLE_FRAGMENT */
        )) : o.icon || n.$slots.icon ? (s(), i(t(g), { key: 1 }, {
          default: r(() => [
            o.icon ? (s(), i(a(o.icon), { key: 0 })) : u(n.$slots, "icon", { key: 1 })
          ]),
          _: 3
          /* FORWARDED */
        })) : b("v-if", !0),
        n.$slots.default ? (s(), k(
          "span",
          {
            key: 2,
            class: y({ [t(e).em("text", "expand")]: t(p) })
          },
          [
            u(n.$slots, "default")
          ],
          2
          /* CLASS */
        )) : b("v-if", !0)
      ]),
      _: 3
      /* FORWARDED */
    }, 16, ["class", "style", "onClick"]));
  }
});
export {
  O as default
};
